import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '/business-conflict',
  name: 'BusinessConflict',
  redirect: '/business-conflict/create',
  component: Layout,
  meta: {
    title: '经营冲突管理',
    icon: 'business-conflict|svg'
  },
  children: [
    {
      path: 'create',
      name: 'BusinessConflictManagement',
      component: () => import('@/views/BusinessConflictManagement/index.vue'),
      meta: {
        title: '经营冲突管理',
        showGuideIcon: true,
        module: 'BUS_CONFLICT_MANAGE'
      }
    }
  ]
}
export default routes
